import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AbmGlobalMessageService {
    public menuChangeEvent$: ReplaySubject<number> = new ReplaySubject();
}
